module.exports = {"140302001":"上站街道","140302002":"下站街道","140302003":"北大街街道","140302004":"南山路街道","140302005":"义井街道","140302006":"坡底街道","140302100":"义井镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140302.json
// module id = 285
// module chunks = 0